import type { ReactNode } from "react";

const initRenderCount = () => {
  let renderCount = 0;

  return {
    getRenderCount: () => renderCount,
    incrementRenderCount: () => {
      const isClient = typeof window !== "undefined";
      if (isClient) {
        renderCount++;
      }
    },
  };
};

const renderCount = initRenderCount();

export const getRenderCount = renderCount.getRenderCount;

export const RenderCount = ({ children }: { children: ReactNode }) => {
  renderCount.incrementRenderCount();

  return children;
};
